// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabGroup {
  min-height: 300px;
  height: 300px;
}

.mat-mdc-list-base {
  padding-top: 8px;
  display: flex;
  -webkit-tap-highlight-color: transparent;
  justify-content: left;
  flex-wrap: wrap;
}

/* TODO(mdc-migration): The following rule targets internal classes of list that may no longer apply for the MDC version. */
.mat-mdc-list-base .mat-mdc-list-item,
.mat-mdc-list-base .mat-list-option {
  display: inline;
  height: 48px;
  -webkit-tap-highlight-color: transparent;
  width: 50%;
  padding: 0;
}

::ng-deep .mdc-list-item__start {
  vertical-align: sub;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/tag-picker-tabs/tag-picker-tabs.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,wCAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA,2HAAA;AACA;;EAEE,eAAA;EACA,YAAA;EACA,wCAAA;EACA,UAAA;EACA,UAAA;AACF;;AAGE;EACE,mBAAA;AAAJ","sourcesContent":[".tabGroup {\r\n  min-height: 300px;\r\n  height: 300px;\r\n}\r\n\r\n.mat-mdc-list-base {\r\n  padding-top: 8px;\r\n  display: flex;\r\n  -webkit-tap-highlight-color: transparent;\r\n  justify-content: left;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of list that may no longer apply for the MDC version. */\r\n.mat-mdc-list-base .mat-mdc-list-item,\r\n.mat-mdc-list-base .mat-list-option {\r\n  display: inline;\r\n  height: 48px;\r\n  -webkit-tap-highlight-color: transparent;\r\n  width: 50%;\r\n  padding: 0;\r\n}\r\n\r\n::ng-deep {\r\n  .mdc-list-item__start {\r\n    vertical-align: sub;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
